const zeroPoint = {
  x: 0,
  y: 0,
  z: 0
};
const isNum = v => typeof v === 'number';
export { isNum, zeroPoint };